<template>
  <b-button @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? 'Привязка' : ''"><i class="fa fa-link"></i></b-button>
</template>

<script>

export default ({
  name: "button-link",
  props: {    
    variant: {
      type: String,
      default: 'primary'
    },
  },
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    },    
  }
})
</script>
